/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('RegisterCtrl', ['$rootScope', '$scope', 'MainService', 'NetworkService', 'Notification', function ($rootScope, $scope, MainService, NetworkService, Notification) {

        var isset = function (field)
        {
            var ret = field != undefined && field != "" && field != " ";
            //if(!ret)
            return ret
        }

        $scope.acceptedDatasafety = false;
        $(document).ready(function () {
            $("label[for=geburtstag]").attr("class", "active")
        })


        /*$scope.getCaptcha = function (callback)
        {

        }*/
        $scope.checkFields = function (data)
        {
            var ret = true
            /*ret = false
             if (isset(data.anrede) && isset(data.vorname) && isset(data.nachname) && isset(data.handynummer) && isset(data.email) && isset(data.geburtstag) && isset(data.passwort))
             {
             ret = true
             }
             if (data.profilePic == "-1")
             {
             ret = false;
             }
             if ($scope.passwort != $scope.passwortRepeat)
             {
             ret = false;
             $scope.error("Passwörter stimmen nicht überein")
             }

             return ret;*/
            var pic = MainService.getProfilePic()
            if (!isset($scope.anrede))
            {
                console.log("andrede fehlt")
                $("input[name=Anrede]").css("background-color", "#FF4081")
                $("input[name=Anrede]").focus()
                ret = false;
            }
            if (!isset($scope.vorname))
            {
                console.log("vorname fehlt")
                $("input[name=vorname]").css("background-color", "#FF4081")
                $("input[name=vorname]").focus()
                ret = false;
            }
            if (!isset($scope.nachname))
            {
                console.log("nachname fehlt")
                $("input[name=nachname]").css("background-color", "#FF4081")
                $("input[name=nachname]").focus()
                ret = false;
            }
            if (!isset($scope.geburtstag))
            {
                console.log("geburtstag fehlt")
                $("input[name=geburtstag]").css("background-color", "#FF4081")
                $("input[name=geburtstag]").focus()
                ret = false;
            }
            if (!isset($scope.handynummer))
            {
                console.log("handynummer fehlt")
                $("input[name=handynummer]").css("background-color", "#FF4081")
                $("input[name=handynummer]").focus()
                ret = false;
            }
            if (!isset($scope.email))
            {
                console.log("emailm fehlt")
                $("input[name=email]").css("background-color", "#FF4081")
                $("input[name=email]").focus()
                ret = false;
            }
            if (pic == -1)
            {
                console.log("Bild fehlt")
                $("#bildInput").parent().css("background-color", "red !important")
                $("bildInput").focus()
                ret = false;
            }
            if (!isset($scope.email))
            {
                console.log("Email fehlt")
                $("input[name=email]").css("background-color", "#FF4081")
                $("input[name=email]").focus()
                ret = false;
            }


            return ret;
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        $scope.success = function (msg) {
            Notification.success(msg);
        };

        $scope.error = function (msg) {
            Notification.error(msg);
        };

        $scope.register = function ()
        {
            //var c = grecaptcha.getResponse();
            c = 2
            NetworkService.checkCaptcha(c, function (data) {
                //if (data.success)
                if(true)
                {
                    data = {anrede: $scope.anrede,
                        vorname: $scope.vorname,
                        nachname: $scope.nachname,
                        strasse: $scope.strasse,
                        postleitzahl: $scope.postleitzahl,
                        ort: $scope.ort,
                        tshirtgroesse: $scope.tshirtgroesse,
                        handynummer: $scope.handynummer,
                        email: $scope.email,
                        magruppe: $scope.magruppe,
                        essen: $scope.essen,
                        passwort: $scope.passwort,
                        referenz: $scope.referenz,
                        geburtstag: $scope.geburtstag,
                        profilePic: MainService.getProfilePic()}
                    if ($scope.checkFields(data))
                    {

                        if (validateEmail(data.email))
                        {
                            NetworkService.addUser(data, function (data) {
                                if (data.done)
                                {

                                    $scope.success("Registrierung erfolgreich");
                                    $("#loginHeadButon a").click()
                                    $rootScope.$emit("showEmailHint")
                                } else if (data.error == 11)
                                {
                                    $scope.error("Sie sind bereits registriert")
                                    $("#loginHeadButon a").click()
                                }
                            })
                        } else
                        {

                            $scope.error("ungültige Email adresse")

                        }

                    } else
                    {
                        $scope.error("Pflichtfeld fehlt")
                    }
                } else
                {
                    $scope.error("Captcha ist falsch, bitte probiere es erneut")
                }
            })
            /*
             */


        }

        $(document).ready(function () {
            //$('select:not([multiple])').material_select();
            $('.datetimepicker').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD', time: false}
            );

            $('#geburtsTagDate').bootstrapMaterialDatePicker(
                    {format: 'YYYY-MM-DD', time: false,
                        currentDate: '1990-01-01',
                        cancelText: 'Abbrechen'}
            );
        }
        )

        $(document).ready(function () {


            $("#loginHeadButon").on("click", function () {
                $("#right").css("display", "block")
                $("#left").css("display", "none")
            })

            $("#registerHeadButton").on("click", function () {
                $("#right").css("display", "none")
                $("#left").css("display", "block")
            })

            $('ul.tabs').tabs();




            $(document).ready(function () {
                // Select - Single
                $('select:not([multiple])').material_select();
            });

        })



    }]);
